
import React from 'react';

interface LogoProps {
  className?: string;
  color?: 'orange' | 'black' | 'white';
  width?: number;
  height?: number;
}

export const Logo: React.FC<LogoProps> = ({ 
  className = '', 
  width = 150,
  height = 40
}) => {
  return (
    <img 
      src="/lovable-uploads/753f375c-83b4-4a92-a62f-7aa150906582.png" 
      alt="Dommek Logo" 
      className={className}
      width={width}
      height={height}
    />
  );
};
